import React from 'react';
import Select from 'react-select';
import { useDispatch } from 'react-redux';
import { setSelectedValue } from '../../../../../store/reducers/campaign';
import { placeholderStyle } from '../../../../AddSegment/Condition/Condition.constants';
import {
  FormatGroupLabel,
  MultiValueLabel,
  MultiValueRemove,
} from '../../../../AddSegment/components/labels';
import styles from './MultiSelect.module.scss';

const MultiSelect = ({ conditionId, label, value, data, getOptionLabel }) => {
  const dispatch = useDispatch();

  const handleChange = (newValue) => {
    dispatch(setSelectedValue({ conditionId, label, value: newValue }));
  };

  return (
    <div className={styles.wrapper}>
      <Select
        styles={placeholderStyle}
        maxMenuHeight={194}
        components={{
          // eslint-disable-next-line react/no-unstable-nested-components
          MultiValueRemove: (props) => (
            <MultiValueRemove props={props} show="label" />
          ),
          // eslint-disable-next-line react/no-unstable-nested-components
          MultiValueLabel: (props) => (
            <MultiValueLabel props={props} show="label" />
          ),
        }}
        getOptionLabel={getOptionLabel}
        formatGroupLabel={FormatGroupLabel}
        value={value}
        options={data}
        hideSelectedOptions
        isSearchable
        onChange={handleChange}
        isShowValue
        isMulti
      />
    </div>
  );
};

export default MultiSelect;
